<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid admin-user-total-points">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4 pointsContiner">
            <div class="row">
              <div class="col-sm-4 col-md-4">
                <h6>Bulletins</h6>
              </div>
            </div>
            <div class="addBulletin">
              <a-button type="primary"><router-link :to="{ name: 'AddBulletin' }"> + Add Bulletin </router-link></a-button>
            </div>
            <div><h8>Select a Bulletin to edit or delete </h8></div>
            <div>
              <a-select size="default" class="editBulletin"> </a-select
              ><a-button type="primary"
                ><router-link :to="{ name: 'EditBulletin', params: { bulletinId: 0 } }"> Edit Bulletin </router-link></a-button
              >
            </div>
            <hr />
            {{ (activeMenuItem, activeMenu) }}
          </div>
        </transition>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AdminSidebar from '@/views/admin/AdminSidebar.vue';

export default {
  name: 'TotalPoints',

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
  },

  data() {
    return {
      data: [],
    };
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('adminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'communicationBulletin',
        activeMenu: this.activeMenu ? this.activeMenu : 'communication',
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.admin-user-total-points {
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.select-width {
  width: 50%;
}

.align-right {
  text-align: right;
}

.total-points {
  font-weight: bold;
  text-align: right;
}
.pointsContiner {
  margin-top: 5%;
}
.editBulletin {
  width: 250px;
  margin-right: 5%;
}
.addBulletin {
  margin: 2% 0%;
}
</style>
